module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_13.ece32e80.pdf";